import { render, staticRenderFns } from "./TestItem.vue?vue&type=template&id=cb2d5be4&scoped=true&"
import script from "./TestItem.vue?vue&type=script&lang=js&"
export * from "./TestItem.vue?vue&type=script&lang=js&"
import style0 from "./TestItem.vue?vue&type=style&index=0&id=cb2d5be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2d5be4",
  null
  
)

export default component.exports